import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.members');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-members',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.members/view.scss */
/* src/app/page.members/view.scss: no such file or directory */`],
})
export class PageMembersComponent implements OnInit {
    public loading: boolean = false;
    public members: any[] = [];

    public search: any = {
        text: "",
        role: ""
    };

    public roles: string[] = ['admin', 'user', 'editor', 'viewer'];

    public showInviteModal: boolean = false;
    public inviteData: any = { email: '', role: 'user' };

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        if (this.service.auth.status === true) await this.load();
    }

    public async load() {
        this.loading = true;
        await this.service.render();

        const { code, data, message } = await wiz.call("list", this.search);
        if (code === 200) {
            this.members = data || [];
        } else {
            this.members = [];
            await this.service.modal.error(this.responseErrorText(data, message, "멤버 목록을 불러오지 못했습니다."));
        }

        this.loading = false;
        await this.service.render();
    }

    public async filterByRole(role: string) {
        this.search.role = this.search.role === role ? "" : role;
        await this.load();
    }

    public async openInvite() {
        this.inviteData = { email: '', role: 'user' };
        this.showInviteModal = true;
        await this.service.render();
    }

    public async invite() {
        if (!this.inviteData.email) {
            await this.service.modal.error("이메일을 입력해주세요.");
            return;
        }

        const { code, data, message } = await wiz.call("invite", this.inviteData);
        if (code === 200) {
            await this.service.modal.success("초대가 완료되었습니다.");
            this.showInviteModal = false;
            await this.load();
        } else {
            await this.service.modal.error(this.responseErrorText(data, message, "초대에 실패했습니다."));
        }
    }

    public async removeMember(member: any) {
        let res = await this.service.modal.show({
            title: "멤버 제거",
            message: `${member.name}님을 멤버에서 제거하시겠습니까?`,
            action: "제거",
            actionBtn: "error",
            status: "error"
        });
        if (!res) return;

        const { code, data, message } = await wiz.call("remove", { id: member.id });
        if (code === 200) {
            await this.load();
        } else {
            await this.service.modal.error(this.responseErrorText(data, message, "멤버 제거에 실패했습니다."));
        }
    }

    public responseErrorText(data: any, message: any = '', fallback: string = '요청 처리 중 오류가 발생했습니다.') {
        const candidates = [
            data?.error?.message,
            data?.data?.error?.message,
            data?.message,
            data?.data?.message,
            message,
            typeof data?.error === 'string' ? data.error : '',
            typeof data === 'string' ? data : '',
        ];
        const found = candidates.find((value: any) => typeof value === 'string' && value.trim() && value !== '[object Object]');
        return found ? found.trim() : fallback;
    }

    public roleClass(role: string) {
        switch (role) {
            case 'admin': return 'nf-role-admin';
            case 'editor': return 'nf-role-editor';
            case 'viewer': return 'nf-role-viewer';
            default: return 'nf-role-viewer';
        }
    }
}

export default PageMembersComponent;